import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import app from 'store/app/reducer';
import oauth from 'store/oauth/reducer';
import usuarios from 'store/usuarios/reducer';
import practicas from 'store/practicas/reducer';
import cursos from 'store/cursos/reducer';
import informes from 'store/informes/reducer';
import photos from 'store/photos/reducer';

const rootReducer = (history: History<any>) =>
  combineReducers({
    router: connectRouter(history),
    app,
    oauth,
    usuarios,
    practicas: practicas,
    cursos,
    informes,
    photos,
    // ...rest of your reducers
  });

export default rootReducer;
